import Jump from "./Jump";

export enum ActionType {
  JUMP = 0,
}
export const ACTIONS = [Jump];
